import { Directive, inject } from '@angular/core';
import {
  ControlValueAccessor,
  FormControlDirective,
  FormControlName,
  NG_VALUE_ACCESSOR,
  NgControl,
  NgModel,
} from '@angular/forms';

export function injectNgControl() {
  const ngControl = inject(NgControl, { optional: true, self: true });

  if (!ngControl) throw new Error('...');

  if (
    ngControl instanceof FormControlDirective ||
    ngControl instanceof FormControlName ||
    ngControl instanceof NgModel
  ) {
    return ngControl;
  }

  throw new Error('...');
}

// noinspection AngularInvalidSelector
@Directive({
  providers: [
    {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: NoopValueAccessorDirective,
    },
  ],
  standalone: true,
})
export class NoopValueAccessorDirective implements ControlValueAccessor {
  registerOnChange(): void {}

  registerOnTouched(): void {}

  writeValue(): void {}
}
